var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMo = function SvgIconMo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14.087 11.5c-.294 0-.574.059-.834.152.143-.317.238-.67.238-1.046 0-1.49-1.49-2.609-1.49-2.609s-1.491 1.118-1.491 2.609c0 .376.095.73.237 1.046a2.5 2.5 0 0 0-.834-.152c-1.49 0-2.608 1.49-2.608 1.49s1.118 1.492 2.608 1.492c.874 0 1.62-.513 2.087-.937.468.424 1.213.937 2.087.937 1.491 0 2.609-1.491 2.609-1.491s-1.118-1.49-2.609-1.49"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 4.695.309.947h.996l-.806.586.308.948L12 6.59l-.806.586.307-.948-.806-.586h.997zM8.211 6.352l.593.533.69-.399-.324.729.592.533-.793-.083-.324.728-.166-.78-.792-.083.69-.399zM5.438 9.126l.78.166.398-.69.083.792.78.166-.728.324.083.793-.534-.592-.728.324.399-.69zM15.79 6.351l-.593.534-.69-.399.324.728-.593.534.793-.084.324.729.166-.78.793-.083-.69-.399zM18.563 9.126l-.78.166-.399-.69-.083.792-.78.166.729.324-.084.793.534-.592.728.324-.399-.69z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.656a5.2 5.2 0 0 0 3.15-1.06H8.85a5.2 5.2 0 0 0 3.15 1.06M7.217 15.524q.25.57.622 1.06h8.321c.247-.325.457-.68.622-1.06z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMo;